/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { fetchGraphQl } from '@/pdp/api';
import { ProductModel } from '@/pdp/data/models';
import { transformProductData } from '@/pdp/data/transforms';
import { GET_PRODUCT_DATA } from './graphql/getProductData.graphql';

export const getProductData = async (
  sku: string,
  options?: {
    preselectFirstOption?: boolean;
    optionsUIDs?: string[];
  },
  raw?: boolean
): Promise<ProductModel | null> => {
  const { data } = await fetchGraphQl(GET_PRODUCT_DATA, {
    method: 'GET',
    variables: { skus: [sku] },
  });

  const product = data?.products?.[0];

  // If optionsUIDs are provided, override the optionsUIDs from the response
  if (options?.optionsUIDs) {
    product.optionUIDs = options.optionsUIDs;
  }

  if (!product) {
    return null;
  }
  return raw
    ? product
    : transformProductData(product, {
        preselectFirstOption: options?.preselectFirstOption,
      });
};
